import Config from '../../AppConfig';
import {
	EpiAccount,
	EpiAccountDoesNotExist,
	FinancialPlanningSoftware,
} from '../domains/epi.domain';
import { get, put, post } from './core/fetch';

const options = {
	withAuth: true,
	noGateway: false,
};

const url = (key: string) =>
	`${Config.mlcApiPrefix}/advisers/${key}/epiAccounts`;

export const getAccount = async (
	key: string
): Promise<EpiAccount | undefined> => {
	try {
		return (await get(url(key), options)) as EpiAccount;
	} catch (e) {
		if (e.status === 404) {
			return EpiAccountDoesNotExist;
		}
		return undefined;
	}
};

export const createAccount = async (
	key: string,
	password: string,
	fps: FinancialPlanningSoftware[]
): Promise<string | undefined> => {
	try {
		const res: any = await post(
			url(key),
			{ password: password, fps: fps },
			options
		);
		return res.id;
	} catch (err) {
		return undefined;
	}
};

export const updatePassword = async (key: string, password: string) => {
	return await updateAccount(key, { password: password });
};

export const updateFps = async (
	key: string,
	fps: FinancialPlanningSoftware[]
) => {
	return await updateAccount(key, { fps: fps });
};

const updateAccount = async (
	key: string,
	body: any
): Promise<UpdateAccountRes> => {
	try {
		await put(url(key), body, options);
		return UpdateAccountRes.SUCCESS;
	} catch (err) {
		return UpdateAccountRes.ERROR;
	}
};

export enum UpdateAccountRes {
	SUCCESS,
	ERROR,
}
